import { useContext, useEffect } from "react";
import { Modal } from "antd";
import { Icon } from "@iconify/react";
import { MyContext } from "../MyContext/MyProvider";

const Removeselection = ({ isRseletionModalOpen, setisRseletionModalOpen }) => {
  const {
    predefined_entities,
    allowList,
    selectedFiles,
    setSelectedEntitites,
    checkedState,
    setCheckedState,
  } = useContext(MyContext);

  useEffect(() => {
    if (selectedFiles && selectedFiles.length == 0) {
      setSelectedEntitites([]);
      setCheckedState([]);
    }
  }, [selectedFiles]);

  const handleCheckboxChange = (entity) => {
    setCheckedState((prevState) => ({
      ...prevState,
      [entity]: !prevState[entity],
    }));

    if (checkedState[entity]) {
      setSelectedEntitites((prevSelected) =>
        prevSelected.filter((item) => item !== entity)
      );
    } else {
      setSelectedEntitites((prevSelected) => [...prevSelected, entity]);
    }
  };

  const handleOk = () => {
    setisRseletionModalOpen(false);
  };

  const handleCancel = () => {
    setisRseletionModalOpen(false);
  };

  return (
    <Modal
      open={isRseletionModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      className="remove-modal"
      centered={true}
      width="35%"
    >
      <div className="modal-content">
        <h2 className="fw-bold text-medium-black text-center">
          Select Entities
        </h2>
        <div className="modal-div  h-center flex-column">
          <label className="elarge text-dark-gray fw-normal">
            Match Found: {allowList.length}
          </label>
          <h4 className="text-medium-black fw-medium mt-1">
            Check to highlight entities
          </h4>
          <div className="checkboxes-div d-flex flex-column">
            <h4 className="text-medium-black fw-medium mt-1">
              Detected Entitities
            </h4>
            {allowList.map((entity) => (
              <div
                key={entity}
                className="check-txt-div v-center space-between"
              >
                <label className="elarge text-medium-black fw-normal">
                  {entity}
                </label>
                <div className="check-me-div">
                  <input
                    type="checkbox"
                    id={`customCheckbox${entity}`}
                    style={{ display: "none" }}
                    checked={checkedState[entity]}
                    onChange={() => handleCheckboxChange(entity)}
                  />
                  <label
                    htmlFor={`customCheckbox${entity}`}
                    className="customCheckboxLabel"
                  >
                    <span
                      className="customCheckboxTick"
                      style={{
                        background: checkedState[entity]
                          ? "#435AB8 "
                          : "transparent",
                      }}
                    >
                      {checkedState[entity] && (
                        <span>
                          <Icon
                            icon="tabler:check"
                            width={20}
                            height={18}
                            color="#FFFFFF"
                          />
                        </span>
                      )}
                    </span>
                  </label>
                </div>
              </div>
            ))}
            {/* <h4 className="text-medium-black fw-medium mt-1">
              Undetected Entitities
            </h4>
            {predefined_entities.map(
              (entity) =>
                !allowList.includes(entity) && (
                  <div
                    key={entity}
                    className="check-txt-div v-center space-between"
                  >
                    <label className="elarge text-medium-black fw-normal">
                      {entity}
                    </label>
                  </div>
                )
            )} */}
          </div>

          <div className="modal-bottom-btns h-center gap-2">
            <button className="modal-dark-btn" onClick={handleCancel}>
              Close
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Removeselection;
